<template>
	<ModalComponent ref="modalComponentRef" :is-header="false" :is-background-transparent="true">
		<div class="detail-riwayat-withdrawal bg-grey-4 text-sm p-5">
			<div class="flex justify-between items-center mb-5">
				<div class="text-2xl">Detail</div>
				<div>
					<span @click="close()"><IconButtonClose :size-multiplier_prop="0.7" class="cursor-pointer" /></span>
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Status Transaksi</div>
				<div :class="`${withdrawalDetail.status == 'Diproses' ? 'text-gold' : withdrawalDetail.status == 'Berhasil' ? 'text-success' : 'text-red'}`">
					{{ withdrawalDetail.status }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Transaction ID</div>
				<div>
					{{ withdrawalDetail.transactionId }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-5	">
				<div>Tanggal</div>
				<div>
					{{ withdrawalDetail.date }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Pengirim</div>
				<div>
					
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div class="pl-3">Nama</div>
				<div>
					{{ withdrawalDetail.credit.accountName }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div class="pl-3">Bank</div>
				<div>
					{{ withdrawalDetail.credit.bankName }}
					<img :src="withdrawalDetail.credit.bankLogo" alt="" class="logo-bank">
				</div>
			</div>

			<div class="flex justify-between items-center mb-5">
				<div class="pl-3">No. RPED</div>
				<div>
					{{ withdrawalDetail.credit.RpedNumber }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Penerima</div>
				<div></div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div class="pl-3">Nama</div>
				<div>
					{{ withdrawalDetail.debit.accountName }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div class="pl-3">Bank</div>
				<div>
					{{ withdrawalDetail.debit.bankName }}
					<img :src="withdrawalDetail.debit.bankLogo" alt="" class="logo-bank">
				</div>
			</div>

			<div class="flex justify-between items-center mb-5">
				<div class="pl-3">No. Rekening</div>
				<div>
					{{ withdrawalDetail.debit.accountNumber }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Deskripsi</div>
				<div>
					{{ withdrawalDetail.description }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Nominal</div>
				<div>
					Rp {{ withdrawalDetail.amount }}
				</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Biaya Admin</div>
				<div>
					Rp {{ withdrawalDetail.adminFee }}
				</div>
			</div>

		</div>
	</ModalComponent>
</template>

<script>
import ModalComponent from '../../../components/ModalComponent.vue'
import IconButtonClose from '../../../components/icons/IconButtonClose.vue'


export default {
	name: 'DetailRiwayatWithdrawal',

	components: {
		ModalComponent,
		IconButtonClose
	},

	data() {
		return {
			withdrawalDetail: {
				status: '',
				transactionId: '',
				date: '',
				credit: {
					name: '',
					bank: '',
					RpedNumber: ''
				},
				debit: {
					name: '',
					bank: '',
					accountNumber: ''
				},
				description: '',
				amount: '',
				adminFee: ''
			}
		}
	},


	methods: {
		open() {
			this.$refs.modalComponentRef.openModal()
		},

		close() {
			console.log('close')
			this.$refs.modalComponentRef.closeModal()
		},

		setWithdrawalDetail(withdrawalDetail) {
			this.withdrawalDetail = withdrawalDetail
		}
	}
}
</script>

<style scoped>
.detail-riwayat-withdrawal {
	width: 37.5rem;
	max-width: calc(100% - 2.5rem);
}

.logo-bank {
	width: 1.5rem;
	height: 1.5rem;
}
</style>